import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { 
    setInvoiceHistoryLogsLoading, 
    getInvoiceHistoryLogs, 
    resetInvoiceHistory, 
    setInvoiceHistoryColSearchStr,
    setInvoiceHistoryPageSize 
} from '../../../../constants/model-reducers/external/invoice/invoice/invoice-history.settings';
import { httpPost, httpDownload, httpGet } from '../../../../utils/api.utils';
import { getLocalTimeZone, convertToFormatLocalDate, modifyResponse } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    isInvoiceHistoryLoading: false,
    invoiceHistoryTable: DEFAULT_TABLE_RESULT_MODEL
});


const initialState = defaultState();

export const invoiceHistoryActions = {
    getInvoiceHistory: (InvoiceId, pageIndex = 0 ) => async (dispatch, state) =>{
        const { Pagination, Headers } = state().invoiceHistory.invoiceHistoryTable;
        const  formData = {
            DisputeID: InvoiceId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,
            TimeZone: getLocalTimeZone()
        };
        
        dispatch({
            type: setInvoiceHistoryLogsLoading,
            isInvoiceHistoryLoading: true
        });
        const response = await httpPost('external/invoice/getInvoiceHistoryLogs', formData);
        const drop_down = await httpGet('external/invoice/status-dropdown');
        const { data } = drop_down
        const modifiedResponse = modifyResponse(response, data);
        dispatch({
            type: getInvoiceHistoryLogs,
            payload: modifiedResponse
        })
    },
   
    setInvoiceHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { invoiceHistoryTable } = state().invoiceHistory;
        var historyTableHeaderUpd = {
            ...invoiceHistoryTable,
            "Headers": {
                ...invoiceHistoryTable.Headers,
                [key]: {

                    ...invoiceHistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInvoiceHistoryColSearchStr,
            invoiceHistoryTable: historyTableHeaderUpd
        });
    },
    resizeInvoiceHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInvoiceHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    resetInvoiceHistory: () => (dispatch, state) => {
        dispatch({
            type: resetInvoiceHistory
        })
    },
    extractInvoiceHistoryLogs: (InvoiceId) => async (dispatch, state) => {
        const { Headers } = state().invoiceHistory.invoiceHistoryTable;
        const { activeDateFormat } = state().adminSetting;
        const dealName = sessionStorage.getItem('DealName');

        var filename = `ATEM ${dealName} Invoice History - ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;

        var data = {
            DisputeID: InvoiceId,
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            FileName: filename,
        };

        httpDownload('external/invoice/getExtractInvoiceHistoryLogs', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state = initialState, action) =>{
    switch(action.type){
        case setInvoiceHistoryLogsLoading:
            return {...state, isInvoiceHistoryLoading: true };
        case getInvoiceHistoryLogs:
            return {...state, invoiceHistoryTable: action.payload, isInvoiceHistoryLoading: false}
        case setInvoiceHistoryColSearchStr:
            return {
                ...state,
                invoiceHistoryTable: action.invoiceHistoryTable,
            }
        case setInvoiceHistoryPageSize:
            return {
                ...state,
                invoiceHistoryTable: {
                    ...state.invoiceHistoryTable,
                    Pagination: {
                        ...state.invoiceHistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case resetInvoiceHistory:
            return initialState;
        default:
            return state;
    }
}
